import { render, staticRenderFns } from "./list_of_invoices_template.vue?vue&type=template&id=012cf107&"
import script from "./list_of_invoices_template.vue?vue&type=script&lang=js&"
export * from "./list_of_invoices_template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports